import Router from 'next/router'

import {
  sendRouteChangeCompleted,
  sendRouteChangeFailed,
  sendRouteChangeStarted,
} from '../../state/actions/ui/ui'
type Args = {
  dispatch: (...args: Array<any>) => any
  onStart?: (...args: Array<any>) => any
  onComplete?: (...args: Array<any>) => any
  onError?: (...args: Array<any>) => any
}

const handleRouterEvents = ({ dispatch, onStart, onComplete, onError }: Args): void => {
  Router.events.on('routeChangeStart', (url: string): void => {
    dispatch(sendRouteChangeStarted(url))
    // istanbul ignore else
    if (onStart) onStart()
  })
  Router.events.on('routeChangeComplete', (url: string): void => {
    dispatch(sendRouteChangeCompleted(url))
    // istanbul ignore else
    if (onComplete) onComplete()
  })
  Router.events.on('routeChangeError', (url: string): void => {
    dispatch(sendRouteChangeFailed(url))
    // istanbul ignore else
    if (onError) onError()
  })
}

export default handleRouterEvents